import { ICouponProgram } from "@interfaces";
import React, { memo } from "react";
import * as Yup from "yup";
import { Input, Form, Row, Col, FormInstance } from "antd";
import { useYup } from "@validations";
import { useTranslation } from "react-i18next";

import { FormAction } from "src/Components/FormAction";
import { PATH_CDIC_COUPON_LIST } from "@configs";
import { useDispatch } from "react-redux";
import { setLoading } from "@redux";
import { couponApi } from "@api";
import { useNotify } from "@utils";
import { useHistory } from "react-router";

interface IProps {
  coupon?: ICouponProgram;
}

const initValue: Partial<ICouponProgram> = {
  programName: "",
  noOfCoupons: 0,
  availableCoupons: 0,
};

export const CdicProgramForm = memo(({ coupon }: IProps) => {
  const formRef = React.useRef<FormInstance>(null);
  const { YupProgram } = useYup();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { success, error } = useNotify();
  const couponSchema = Yup.object().shape(YupProgram);
  const [couponForm] = Form.useForm();

  const onFinish = async (values: ICouponProgram) => {
    try {
      dispatch(setLoading(true));
      if (coupon && coupon._id) {
        await couponApi.updateProgram(coupon._id, { ...values, noOfCoupons: Number(values.noOfCoupons), availableCoupons: Number(values.noOfCoupons) });
      } else {
        await couponApi.createProgram({ ...values, noOfCoupons: Number(values.noOfCoupons), availableCoupons: Number(values.noOfCoupons) });
      }
      success(t("message.create.success"));
      history.push(PATH_CDIC_COUPON_LIST);
    } catch (err: any) {
      error(t("message.create.fail"));
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  const yupSync = {
    async validator({ field }: any, value: any) {
      await couponSchema.validateSyncAt(field, { [field]: value });
    },
  };

  return (
    <Form
      form={couponForm}
      name="basic"
      ref={formRef}
      initialValues={initValue}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      layout="vertical"
    >
      <Row gutter={{ md: 54, lg: 54 }}>
        <Col lg={12} md={24} sm={24} xs={24}>
          <Form.Item label={t("page.coupon_program_name")} name="programName" rules={[yupSync]}>
            <Input />
          </Form.Item>
        </Col>
        <Col lg={12} md={24} sm={24} xs={24}>
          <Form.Item label={t("page.number_of_coupons")} name="noOfCoupons" rules={[yupSync]}>
            <Input type="number" />
          </Form.Item>
        </Col>
      </Row>
      <FormAction />
    </Form>
  );
});
